export enum SmsProviderType {
    TallBob = 'TallBob'
}